export default "__VITE_ASSET__CN2XQXK5__"